import React from "react";
import PropTypes from "prop-types";
import { hideModal } from "@actions";
import { connect } from "react-redux";
import Form from "@components/form";

const SingleSponsorType = (props) => {
  return (
    <div className="form-container single-sponsor">
      <h2>{`${
        props.mode == "create" ? "Create Sponsor Type" : "Edit Sponsor Type"
      }`}</h2>
      <Form
        formName="sponsorsTypes"
        componentName="clientPanel"
        value={props.item}
        onSubmit={(data) => {
          if (Object.keys(data.errors).length) return false;
          props.onSave(data.value);
        }}
        onCancel={() => {
          props.hideModal();
        }}
      />
    </div>
  );
};

SingleSponsorType.propTypes = {
  hideModal: PropTypes.func,
  mode: PropTypes.string,
  onSave: PropTypes.func,
  item: PropTypes.object,
};

const mapStateToProps = () => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {
    hideModal: () => {
      dispatch(hideModal());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SingleSponsorType);
